export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/util/eventConsts.js
// module id = 2155
// module chunks = 1